// extracted by mini-css-extract-plugin
export default {"container":"authLayout_container__zLHNM","card":"authLayout_card__YyR-C","logo":"authLayout_logo__-mU9s"};